var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.hideForm === false
      ? _c("form", { staticClass: "c-form", on: { submit: _vm.onSubmit } }, [
          _c("h3", { staticClass: "c-form__title" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.lead
            ? _c("div", {
                staticClass: "c-form__lead",
                domProps: { innerHTML: _vm._s(_vm.lead) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "c-form__label-and-input" }, [
            _c("label", { attrs: { for: "name" } }, [_vm._v("Navn*")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formInput.name,
                  expression: "formInput.name",
                },
              ],
              attrs: { id: "name", type: "text", name: "name", required: "" },
              domProps: { value: _vm.formInput.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formInput, "name", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-form__label-and-input" }, [
            _c("label", { attrs: { for: "email" } }, [_vm._v("E-post*")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formInput.email,
                  expression: "formInput.email",
                },
              ],
              attrs: {
                id: "email",
                type: "email",
                name: "email",
                required: "",
              },
              domProps: { value: _vm.formInput.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formInput, "email", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-form__label-and-input" }, [
            _c("label", { attrs: { for: "phone" } }, [_vm._v("Telefon*")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formInput.phone,
                  expression: "formInput.phone",
                },
              ],
              attrs: { id: "phone", type: "text", name: "phone", required: "" },
              domProps: { value: _vm.formInput.phone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formInput, "phone", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-form__label-and-input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formInput.consent,
                  expression: "formInput.consent",
                },
              ],
              attrs: {
                id: "consent",
                type: "checkbox",
                name: "consent",
                required: "",
              },
              domProps: {
                value: _vm.consent,
                checked: Array.isArray(_vm.formInput.consent)
                  ? _vm._i(_vm.formInput.consent, _vm.consent) > -1
                  : _vm.formInput.consent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.formInput.consent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = _vm.consent,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.formInput, "consent", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.formInput,
                          "consent",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.formInput, "consent", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "consent" } }, [
              _vm._v("\n        " + _vm._s(_vm.consent) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: {
                disabled: _vm.formInput.consent != true,
                type: "submit",
                title: "Du må godkjenne før du kan sende inn skjemaet",
              },
            },
            [_vm._v("\n      Send\n    ")]
          ),
        ])
      : _c("div", { staticClass: "c-form" }, [
          _c("h2", [_vm._v("Tusen takk.")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Vi har nå mottatt din melding og vil kontakte deg snarest."
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "c-btn\n      c-btn--secondary",
              attrs: { type: "button" },
              on: {
                click: _vm.showForm,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.showForm($event)
                },
              },
            },
            [_vm._v("\n      Vis skjemaet igjen\n    ")]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }